<div class="d-flex flex-column align-items-center">
    <div class="dialog-header">
        <div class="icon-wrapper">
            <span
                hamIconShapes
                class="no-hover"
                type="square"
                variant="red"
                size="lg"
                icon="assets/hamIcons/x-circle.svg"
                color="red"
            ></span>
        </div>
        <span class="dialog-header__title">{{
            'aumico_users_organization_users_table_withdraw_invite_modal_title' | i18next
        }}</span>
    </div>
    <div class="dialog-body">
        <span class="dialog-body__text">
            {{ 'aumico_users_organization_users_table_withdraw_invite_modal_body' | i18next }}
        </span>
    </div>
</div>
